export const mediaContent = { 
  header: {
    mobile: "https://frontend-assets.buildbox.com/BBW_headerimage_mobile_v2.jpg",
    desktop: "https://frontend-assets.buildbox.com/BBW_Header_v3.mp4"
  },
  footer: {
    mobile: "https://frontend-assets.buildbox.com/BBW_footerimage_mobile.jpg",
    desktop: "https://frontend-assets.buildbox.com/BBW_footerimage_desktop.jpg"
  },
  body: {
    preview: "https://frontend-assets.buildbox.com/Preview_image_v2.png",
    exploreVideo: "https://frontend-assets.buildbox.com/BBW_Explore_Share_Video_leftalign.mp4",
    explore: "https://frontend-assets.buildbox.com/BBW_Explore_Share_Image.png",
    bbMascot:"https://frontend-assets.buildbox.com/BoxMascot_pose_v2.png",
    bbBee: "https://frontend-assets.buildbox.com/Beebee_pose_v2.png",
    qrCode: "https://frontend-assets.buildbox.com/BBW_QR_Code.svg",
    downloadBB3: "https://frontend-assets.buildbox.com/DL_bb3_button.png",
    learnMore: "https://frontend-assets.buildbox.com/LearnMore_button.png"
  }
}

export const HomeSectionOne = {
  backgroundImg:
    mediaContent.header.desktop,
    mobileImg: mediaContent.header.mobile,
  headerText: "Play.\n Share.\n Preview.\n",
  subtext:
    "Instantly export your Buildbox creations directly to your phone! Previewing and playing on device is faster than ever before. Test, analyze, and iterate with ease.",
  slideupImg: "",
  textBlockClassName: "heroOneHeader",
  id: 1,
  overlay: false,
  customClass: "",
};

export const HomeSectionTwo = {
  backgroundImg:
    "https://frontend-assets.buildbox.com/2_Buildbox_Laptop_NEW.png",
  headerText: "Test, analyze,\n and iterate\n with ease",
  subtext: "",
  slideupImg: "null",
  textBlockClassName: "blockquote",
  id: 2,
  overlay: false,
  customClass: "hero-two-image",
  qrCode: mediaContent.body.qrCode,
  bbMascot: mediaContent.body.bbMascot,
  bbBee: mediaContent.body.bbBee,
  topHalfText: "Scan QR code to download Buildbox World to your iOS or Android mobile device.",
  bottomHalfHeader: "What is a bit?",
  bottomHalfText: "If you haven’t heard, a bit is a new term we’re using for your Buildbox World exports. Bits can be anything your imagination can come up with! The best bits are bite-sized game experiences."
  
};

export const HomeSectionThree = {
  backgroundDesktop: mediaContent.body.exploreVideo,
  backgroundMobile: mediaContent.body.explore,
  headerText1: "Explore",
  text1: "On Buildbox World for Android, check out the Explore tab to find new and exciting bits shared by Buildbox creators from all around the world.",
  headerText2: "Share",
  text2: "Inspired by what you’ve discovered in the Explore tab? Choose to publicly share your own bit directly from Buildbox to the Buildbox World for Android Explore feed, or directly to your friends using a unique URL.",
  subtext: "",
  slideupImg: null,
  textBlockClassName: "blockquote",
  id: 3,
  overlay: true,
  customClass: "",
  leftImg: "",
};

export const HomeSectionFour = {
  backgroundImg: mediaContent.body.preview,
  headerText: "Preview",
  subtext: "",
  slideupImg: "",
  textBlockClassName: "blockquote",
  id: 4,
  overlay: false,
  customClass: "hero-four-image",
  leftText:{
    top: "Test, preview, and now share, your Bits with ease. Get a true sense of the experience by previewing and playing them right in the palm of your hands.",
    bottom: "Buildbox World exports directly from the Buildbox 3 desktop application to your phone. If you don't have Buildbox 3 yet, click below to:",
    btn1: mediaContent.body.downloadBB3,
    btn2: mediaContent.body.learnMore,
  },
};

export const HomeSectionFive = {
  footerText: {
    header: "Join the Buildbox World community!",
    text: "Download Buildbox World now to share and discover bits by Buildbox creators from all over the world.",
  },
  qrCode: mediaContent.body.qrCode,
  desktopImg: mediaContent.footer.desktop
}

// http://frontend-assets.buildbox.com/3_ExportWindow_new.png"